import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {buildMailDraft,type MailDocument} from '@hisense/shared';
import {useMailAccounts,useSendMail} from '@/api/hooks';
import {Modal} from '@/components/ui/Modal';
import {Button} from '@/components/ui/Button';
import {Input,FieldLabel} from '@/components/ui/Input';
import {Select} from '@/components/ui/Select';
import {getLocalizedError} from '@/lib/api';

/**
 * Soạn và gửi thư kèm chứng từ.
 *
 * Nội dung dựng sẵn từ chứng từ đang mở và SỬA ĐƯỢC trước khi gửi. Người nhận
 * gõ tay; người gửi chọn một trong các hòm thư đã cấu hình.
 *
 * Chưa có hòm thư nào thì nói thẳng ở đầu hộp thoại và khoá nút gửi. Không
 * dựng nút "Gửi" bấm được rồi báo lỗi sau — người dùng sẽ tưởng thư đã đi.
 */
export function SendDocumentMail({doc,onClose}:{doc:MailDocument;onClose:()=>void}){
 const {t}=useTranslation();
 const accounts=useMailAccounts();
 const send=useSendMail();
 const draft=buildMailDraft((k,v)=>t(k,v??{}),doc);
 const [from,setFrom]=useState('');
 const [to,setTo]=useState('');
 const [subject,setSubject]=useState(draft.subject);
 const [body,setBody]=useState(draft.body);
 const [error,setError]=useState<string|null>(null);
 const list=accounts.data??[];
 const ready=list.length>0;
 const submit=async()=>{
  setError(null);
  try{await send.mutateAsync({from:from||list[0]?.id||'',to,subject,body,documentNo:doc.documentNo,kind:doc.kind});onClose();}
  catch(e){setError(getLocalizedError(e,t,'mail.error'));}
 };
 return <Modal title={t('mail.title')} closeLabel={t('common.close')} onClose={onClose} className="max-w-2xl">
  <div className="space-y-3 p-4">
   {!ready&&<p role="status" className="rounded-sm border border-warn/30 bg-warn-tint p-3 text-sm">{t('mail.notConfigured')}</p>}
   <div>
    <FieldLabel htmlFor="mail-from">{t('mail.from')}</FieldLabel>
    <Select id="mail-from" containerClassName="w-full" value={from} disabled={!ready} onChange={e=>setFrom(e.target.value)}>
     {list.length===0&&<option value="">{t('mail.noMailbox')}</option>}
     {list.map(a=><option key={a.id} value={a.id}>{a.label?`${a.label} · ${a.address}`:a.address}</option>)}
    </Select>
   </div>
   <div>
    <FieldLabel htmlFor="mail-to">{t('mail.to')}</FieldLabel>
    <Input id="mail-to" type="email" value={to} onChange={e=>setTo(e.target.value)} placeholder={t('mail.toPlaceholder')}/>
   </div>
   <div>
    <FieldLabel htmlFor="mail-subject">{t('mail.subjectLabel')}</FieldLabel>
    <Input id="mail-subject" value={subject} onChange={e=>setSubject(e.target.value)}/>
   </div>
   <div>
    <FieldLabel htmlFor="mail-body">{t('mail.body')}</FieldLabel>
    <textarea id="mail-body" rows={10} value={body} onChange={e=>setBody(e.target.value)}
      className="w-full rounded-sm border border-line-strong bg-surface px-2.5 py-2 text-sm text-ink outline-none focus:border-brand"/>
   </div>
   {error&&<p role="alert" className="text-sm text-danger">{error}</p>}
   <div className="flex justify-end gap-2">
    <Button variant="secondary" onClick={onClose}>{t('common.cancel')}</Button>
    <Button disabled={!ready||send.isPending||!to.trim()} onClick={()=>void submit()}>{t('mail.send')}</Button>
   </div>
  </div>
 </Modal>;
}
